import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { doc, updateDoc, setDoc } from 'firebase/firestore';
import { db } from '../firebase/config';
import app from '../firebase/config';

// Initialize messaging (only in supported browsers)
let messaging = null;
try {
  if ('Notification' in window && 'serviceWorker' in navigator) {
    messaging = getMessaging(app);
  }
} catch (e) {
  console.log('FCM not supported in this browser');
}

export function isNotificationSupported() {
  return 'Notification' in window && 'serviceWorker' in navigator && messaging !== null;
}

export function getNotificationPermission() {
  if (!('Notification' in window)) return 'unsupported';
  return Notification.permission; // 'default', 'granted', 'denied'
}

export async function requestNotificationPermission(userId) {
  if (!messaging || !userId) return false;

  try {
    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      const token = await getToken(messaging, {
        vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY
      });

      if (token) {
        const userPrefRef = doc(db, 'userPreferences', userId);
        await updateDoc(userPrefRef, {
          fcmToken: token,
          goalRemindersEnabled: true
        }).catch(async () => {
          // Document might not exist yet — create it
          await setDoc(userPrefRef, {
            fcmToken: token,
            goalRemindersEnabled: true
          }, { merge: true });
        });

        return true;
      }
    }
    return false;
  } catch (error) {
    console.error('Error requesting notification permission:', error);
    return false;
  }
}

// Listen for foreground messages
export function onForegroundMessage(callback) {
  if (!messaging) return () => {};
  return onMessage(messaging, callback);
}
